export default {
  en: {
    remark: 'Remark',
    editRemark: 'Edit Remark',
    save: 'Save Changes',
    cancel: 'Cancel',
    saveRemarkSuccessTitle: 'Success',
    saveRemarkSuccessMessage: 'Save Remark Success'
  },
  th: {
    remark: 'หมายเหตุ',
    editRemark: 'แก้ไขหมายเหตุ',
    save: 'บันทึก',
    cancel: 'ยกเลิก',
    saveRemarkSuccessTitle: 'สำเร็จ',
    saveRemarkSuccessMessage: 'แก้ไขหมายเหตุสำเร็จ'
  }
}
